import React from 'react';
import PageItem from "react-bootstrap/PageItem";
import Pagination from "react-bootstrap/Pagination";

const CustomPaginator = ({totalCount, activePage, setActivePage, resultsPerPage}) => {
  if (!totalCount) {
    return '';
  }

  const pagesNeeded = Math.ceil(totalCount / resultsPerPage);

  if (pagesNeeded === 1) {
    return '';
  }

  const paginationItems = [];
  for (let number = 1; number <= pagesNeeded; number++) {
    paginationItems.push(
      <PageItem key={number} active={number === activePage} onClick={() => setActivePage(number)}>
        {number}
      </PageItem>,
    );
  }

  return (<Pagination>{paginationItems}</Pagination>);
}

export default CustomPaginator;